import { render, staticRenderFns } from "./ParkPrice.vue?vue&type=template&id=3d64649e&"
import script from "./ParkPrice.vue?vue&type=script&lang=ts&"
export * from "./ParkPrice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports